/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PuzzlePieceIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA50lEQVR4nO2VvYpCMRCFr4I22ug7WelMxmKYUawvrIKvcMtVRH1J/1DYLS2VyPqDJrsbMcUFD5wmnJxvAiFJkrdCxcxlJBmDkRWSHk42us6yrOiIF5Bkc84ByRJJR7bDC7CBSzFdzcx1xzB1V9Z2eAE/UzxuauvgYZi2Dl1Z2/HbCVwTHdDIHkg+mLnaaPQqLdPp2zVfPhxAYXaWN5vdWhQAM5fB6BRIvqMAkGT+qmL0AHZxAUa3UQFAMosKSNO0hKQTJPnK5zW9Vf4B4HvsKMiL4OcaAwxGP//4cHT0zEngPx/OW8mdjhlucxl7XldVAAAAAElFTkSuQmCC)
 */
export const PuzzlePieceIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 4a3 3 0 1 1-5.98-.31c.03-.35-.21-.69-.56-.69H7a3 3 0 0 0-3 3v2.5c0 .28-.23.5-.5.54a3 3 0 0 0 0 5.92c.27.04.5.26.5.54V18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.46c-.35 0-.6.34-.56.69L16 4Z"
        className={colorClass}
      />
    </svg>
  );
};
